import "./Components/sentry";

import jQuery from "./Components/jQuery";

import "jquery-colorbox";
import "jquery-colorbox/i18n/jquery.colorbox-nl";
import "jquery-colorbox/example5/colorbox.css";

// Component JS
import "./Components/mmenu";

// jQuery document ready
jQuery(document).ready(function () {
  initializeDefaultColorbox();

  expandAndPositionMenuItems();

  initBackgroundSlider();

  initTestimonialSlider();

  wrapAndBindFaqItems();
});

/**
 * Get all FAQ-items on page and wrap them with some HTML
 * Then bind click-event
 */
function wrapAndBindFaqItems() {
  // get all matching elements on page
  let $questions = jQuery(".FAQ_Question");

  // define wrapping HTML
  let $FAQwrapper = "<div class='FAQ_Wrapper FAQ_Wrapper--collapsed'></div>";

  // loop through array
  $questions.each(function (i) {
    // wrap answers with one container
    jQuery(this)
      .nextUntil(".FAQ_Question")
      .wrapAll(
        '<div class="FAQ_AnswersContainer" style="display: none"></div>',
      );

    // get everything after matching element until next match is reached
    jQuery(this)
      .nextUntil(".FAQ_Question")
      // add matching element itself
      .addBack()
      // and wrap with content
      .wrapAll($FAQwrapper);
  });

  // bind click event on questions
  $questions.on("click", function () {
    jQuery(this)
      .closest(".FAQ_Wrapper")
      .toggleClass("FAQ_Wrapper--collapsed")
      .find(".FAQ_AnswersContainer")
      .slideToggle(500);
  });
}

/**
 * Expand mainmenu subitems and (re)position the container relative to its parent, but within content-edges
 */
function expandAndPositionMenuItems() {
  let $parentMenuItems = jQuery(".MainMenu_Item--parent"),
    $logoWidth = jQuery(".Header_Logo").outerWidth();

  $parentMenuItems.on("mouseenter mouseleave", function (e) {
    if (jQuery(".MainMenu_SubitemsContainer", this).length) {
      let $dropdown = jQuery(".MainMenu_SubitemsContainer:first", this),
        $dropdownProperties = {
          leftEdge: Math.round($dropdown.offset().left),
          rightEdge:
            Math.round($dropdown.offset().left) + Math.round($dropdown.width()),
          width: Math.round($dropdown.width()),
        };

      let $currentMenuItem = jQuery(this),
        $currentMenuItemProperties = {
          leftEdge: Math.round($currentMenuItem.offset().left),
          rightEdge:
            Math.round($currentMenuItem.offset().left) +
            Math.round($currentMenuItem.width()),
          width: Math.round($currentMenuItem.width()),
        };

      let $wrapper = jQuery(".MenuWrapper--desktop"),
        $wrapperProperties = {
          leftEdge: Math.round($wrapper.offset().left),
          rightEdge:
            Math.round($wrapper.offset().left) + Math.round($wrapper.width()),
          width: Math.round($wrapper.width()),
        };

      let staysInsideContentContainer =
        $dropdownProperties.rightEdge <= $wrapperProperties.rightEdge;

      if (!staysInsideContentContainer) {
        if (
          $dropdownProperties.leftEdge - $wrapperProperties.leftEdge - 16 <
          $currentMenuItemProperties.rightEdge
        ) {
          $dropdown.css(
            "left",
            ($dropdownProperties.leftEdge -
              $wrapperProperties.leftEdge -
              $currentMenuItemProperties.width -
              32) *
              -1,
          );
        } else {
          $dropdown.css(
            "left",
            ($dropdownProperties.leftEdge - $wrapperProperties.leftEdge) * -1,
          );
        }
      }
    }
  });
}

/**
 * Fullscreen Background Image Slider
 *
 * Fade active item away after * seconds and fade next image back in
 * Returns to first item when no next item is available
 */
function initBackgroundSlider() {
  let $sliderItems = jQuery(".PageBackground_SliderItem"),
    sliderActive = $sliderItems.length > 1,
    $activeItem = jQuery(".PageBackground_SliderItem--active"),
    $nextItem = $activeItem.next() || $sliderItems[0];

  if (!sliderActive) return;

  window.setInterval(nextSlide, 8000);

  function nextSlide() {
    if ($sliderItems.length < 2) return false;

    $activeItem.add($nextItem).toggleClass("PageBackground_SliderItem--active");
  }
}

/**
 * Initialize lightbox on certain content images
 */
function initializeDefaultColorbox() {
  Array.from(document.querySelectorAll(".lightbox")).map((element) => {
    let iframe = false;

    // At the moment, there is no minimal invasive TYPO3-level way to retrieve a video's embed URL.
    // Instead of doing heavy invasive lifting, we simply rewrite the Youtube and Vimeo frontend public URLs to embed URLs.

    // Fix issues with unsupportive browser
    Element.prototype.matches =
      Element.prototype.matches || Element.prototype.msMatchesSelector;

    // YouTube rewriting
    if (element.matches('[href^="https://www.youtube.com/watch?v="]')) {
      element.href = element.href.replace("/watch?v=", "/embed/");
      iframe = true;

      // Vimeo rewriting
    } else if (element.matches('[href^="https://vimeo.com/"]')) {
      element.href = element.href.replace(
        "https://vimeo.com/",
        "https://player.vimeo.com/video/",
      );
      iframe = true;
    }

    let colorboxOptions = {
      maxWidth: "100%",
      maxHeight: "100%",
      initialWidth: 80,
      initialHeight: 60,
      scrolling: false,
    };

    // Since YouTube does not send a CORS 'Access-Control-Allow-Origin' header,
    // we cannot load the embed code via XHR.
    // Instead, colorbox needs to switch to the `iframe` method for embedded videos.
    if (iframe) {
      colorboxOptions.iframe = true;
      colorboxOptions.width = "100%";
      colorboxOptions.height = "100%";
    }

    // Standard lightbox:
    jQuery(element).colorbox(colorboxOptions);
  });
}

/**
 * Testimonial Slider (Spotlight)
 *
 * Fade active item away after * seconds and fade next image back in
 * Returns to first item when no next item is available
 */
function initTestimonialSlider() {
  let $sliderItems = jQuery(
      ".SpotlightSlider_Item",
      ".SpotlightSlider.js-slider-active",
    ),
    $activeItem = jQuery(".SpotlightSlider_Item--active"),
    $nextItem = $activeItem.next() || $sliderItems[0];

  window.setInterval(nextSlide, 8000);

  function nextSlide() {
    if ($sliderItems.length < 2) return false;

    $activeItem.add($nextItem).toggleClass("SpotlightSlider_Item--active");
  }
}
